module.exports = __webpack_public_path__ + "assets/img/banner.2de59ebc.jpg";